import { useState } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import PortofoliuCard from './PortofoliuCard';

import ProiectInfoCuToni from '../../assets/projects/ProiectInfoCuToni.jpg';
import InfoCuToni1 from '../../assets/projects/InfoCuToni1.jpg';
import InfoCuToni2 from '../../assets/projects/InfoCuToni2.jpg';
import InfoCuToni3 from '../../assets/projects/InfoCuToni3.jpg';
import ProiectAjutor from '../../assets/projects/ProiectAjutor.jpg';
import Ajutor1 from '../../assets/projects/Ajutor1.jpg';
import Ajutor2 from '../../assets/projects/Ajutor2.jpg';
import Ajutor3 from '../../assets/projects/Ajutor3.jpg';
import ProiectChimie from '../../assets/projects/ProiectChimie.jpg';
import Chimie1 from '../../assets/projects/Chimie1.jpg';
import Chimie2 from '../../assets/projects/Chimie2.jpg';
import Chimie3 from '../../assets/projects/Chimie3.jpg';
import ProiectSpace from '../../assets/projects/ProiectSpace.jpg';
import Space1 from '../../assets/projects/Space1.jpg';
import Space2 from '../../assets/projects/Space2.jpg';
import Space3 from '../../assets/projects/Space3.jpg';
import ProiectFreelancer from '../../assets/projects/ProiectFreelancer.jpg';
import Freelancer1 from '../../assets/projects/Freelancer1.jpg';
import Freelancer2 from '../../assets/projects/Freelancer2.jpg';
import Freelancer3 from '../../assets/projects/Freelancer3.jpg';
import ProiectFreelancer2 from '../../assets/projects/ProiectFreelancer2.jpg';
import Freelancer21 from '../../assets/projects/Freelancer21.jpg';
import Freelancer22 from '../../assets/projects/Freelancer22.jpg';
import Freelancer23 from '../../assets/projects/Freelancer23.jpg';
import ProiectGCCC from '../../assets/projects/GCCC.jpg';
import CCC1 from '../../assets/projects/CCC1.jpg';
import CCC2 from '../../assets/projects/CCC2.jpg';
import CCC3 from '../../assets/projects/CCC3.jpg';
import ProiectSign from '../../assets/projects/ProiectSign.jpg';
import Sign1 from '../../assets/projects/Sign1.jpg';
import Sign2 from '../../assets/projects/Sign2.jpg';
import Sign3 from '../../assets/projects/Sign3.jpg';
import ProiectMental from '../../assets/projects/ProiectMental.jpg';
import Mental1 from '../../assets/projects/Mental1.jpg';
import Mental2 from '../../assets/projects/Mental2.jpg';
import Mental3 from '../../assets/projects/Mental3.jpg';
import ProiectWordScramble from '../../assets/projects/ProiectWordScramble.jpg';
import WS1 from '../../assets/projects/WS1.jpg';
import WS2 from '../../assets/projects/WS2.jpg';
import WS3 from '../../assets/projects/WS3.jpg';
import ProiectHangMan from '../../assets/projects/ProiectHangMan.jpg';
import HM1 from '../../assets/projects/HM1.jpg';
import HM2 from '../../assets/projects/HM2.jpg';
import HM3 from '../../assets/projects/HM3.jpg';
import ProiectLitere from '../../assets/projects/ProiectLitere.jpg';
import Joc1 from '../../assets/projects/Joc1.jpg';
import Joc2 from '../../assets/projects/Joc2.jpg';
import Joc3 from '../../assets/projects/Joc3.jpg';
import ProiectPA from '../../assets/projects/ProiectPA.jpg';
import PA1 from '../../assets/projects/PA1.jpg';
import PA2 from '../../assets/projects/PA2.jpg';
import PA3 from '../../assets/projects/PA3.jpg';
import ProiectCT from '../../assets/projects/ProiectCT.jpg';
import CT1 from '../../assets/projects/CT1.jpg';
import CT2 from '../../assets/projects/CT2.jpg';
import CT3 from '../../assets/projects/CT3.jpg';
import ProiectHackIT from '../../assets/projects/ProiectHackIT.jpg';
import HackIT1 from '../../assets/projects/HackIT1.jpg';
import HackIT2 from '../../assets/projects/HackIT2.jpg';
import HackIT3 from '../../assets/projects/HackIT3.jpg';
import ProiectCSA from '../../assets/projects/ProiectCSA.jpg';
import CSA1 from '../../assets/projects/CSA1.jpg';
import CSA2 from '../../assets/projects/CSA2.jpg';
import CSA3 from '../../assets/projects/CSA3.jpg';
import ProiectGAP from '../../assets/projects/ProiectGAP.jpg';
import GAP1 from '../../assets/projects/GAP1.jpg';
import GAP2 from '../../assets/projects/GAP2.jpg';
import GAP3 from '../../assets/projects/GAP3.jpg';

import './Portofoliu.css';

export default function Portofoliu() {
    const [view, setView] = useState("All");

    return (
        <Container className="portofoliuContainer worldwide">
            <p className="portofoliuTitle">
                <span className="bracket">{'<'}</span>
                Portofoliu
                <span className="bracket">{'/>'}</span>
            </p>
            <p className="portofoliuSubTitle">Proiecte personale din domeniul IT</p>
            
            <div className="selectProject">
                <Button variant="outline-dark" className={view === "All" ? "selectButton" : "noSelectButton"} onClick={() => setView("All")}>Toate</Button>
                <Button variant="outline-dark" className={view === "Website-uri" ? "selectButton" : "noSelectButton"} onClick={() => setView("Website-uri")}>Website-uri</Button>
                <Button variant="outline-dark" className={view === "Hackathon" ? "selectButton" : "noSelectButton"} onClick={() => setView("Hackathon")}>Hackathon</Button>
                <Button variant="outline-dark" className={view === "Jocuri" ? "selectButton" : "noSelectButton"} onClick={() => setView("Jocuri")}>Jocuri</Button>
                <Button variant="outline-dark" className={view === "Proiecte" ? "selectButton" : "noSelectButton"} onClick={() => setView("Proiecte")}>Proiecte / Teme</Button>
                <Button variant="outline-dark" className={view === "Departament" ? "selectButton" : "noSelectButton"} onClick={() => setView("Departament")}>Proiecte Departamentul IT</Button>
            </div>

            {(view === "All" || view === "Website-uri") && 
                <>
                    <p className="subSubTitle">&lt;Website-uri/&gt;</p>
                    <Row>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="yes" linkToGitHub="yes"
                                img={ProiectInfoCuToni} img1={InfoCuToni1} img2={InfoCuToni2} img3={InfoCuToni3}
                                title={<>info-cu-toni - Web App</>}
                                description={<>Aplicație web realizată pentru a-mi promova pregătirile individuale
                                la informatică, tehnologii web și matematică.</>}
                                technology={<>React, JavaScript, HTML, Bootstrap, CSS</>}
                                git="https://github.com/AntonioCC147/info_cu_toni" adress="https://info-cu-toni.ro/"
                            />
                        </Col>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="yes" linkToGitHub="no"
                                img={ProiectAjutor} img1={Ajutor1} img2={Ajutor2} img3={Ajutor3}
                                title={<>Ajutor! Dau Bacu' - Web App</>}
                                description={<>Aplicație web realizată pentru un proiect educațional bazat pe simulări de
                                bacalaureat cu sistem înscrieri integrat.</>}
                                technology={<>React, JavaScript, HTML, Bootstrap, CSS</>}
                                git="/" adress="https://ajutor-dau-bacu.ro/"
                            />
                        </Col>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="yes" linkToGitHub="yes"
                                img={ProiectChimie} img1={Chimie1} img2={Chimie2} img3={Chimie3}
                                title={<>Chemistry App - Web App</>}
                                description={<>Proiectul a fost realizat la "Sesiunea de Comunicări Științifice" și reprezintă o
                                aplicație pentru laboratoarele de chimie.</>}
                                technology={<>React, JavaScript, HTML, Bootstrap, CSS</>}
                                git="https://github.com/AntonioCC147/Chemistry-App" adress="https://acs-chemistry-app.netlify.app/"
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="yes" linkToGitHub="yes"
                                img={ProiectSpace} img1={Space1} img2={Space2} img3={Space3}
                                title={<>Space Explorer - Web App</>}
                                description={<>Proiectul reprezintă un Landing Page cu tematica spațiului ce conține informații
                                despre planete, specialiști, dar și tehnologii.</>}
                                technology={<>React, JavaScript, HTML, Bootstrap, CSS</>}
                                git="https://github.com/AntonioCC147/Space-Exploring-Website" adress="https://space-exploring.netlify.app/"
                            />
                        </Col>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="yes" linkToGitHub="yes"
                                img={ProiectFreelancer} img1={Freelancer1} img2={Freelancer2} img3={Freelancer3}
                                title={<>Designer1 - Web App</>}
                                description={<>Website-ul este destinat portofoliului unui designer care dorești să-și promoveze
                                serviciile prin intermediul unui site.</>}
                                technology={<>React, JavaScript, HTML, Bootstrap, CSS</>}
                                git="https://github.com/AntonioCC147/Designer-Website" adress="https://designer1-app.netlify.app/"
                            />
                        </Col>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="yes" linkToGitHub="yes"
                                img={ProiectFreelancer2} img1={Freelancer21} img2={Freelancer22} img3={Freelancer23}
                                title={<>Designer2 - Web App</>}
                                description={<>Acest proiect reprezintă un Landing Page creat în scop educativ, în cadrul cursului
                                de Tehnologii Web unde predau React.</>}
                                technology={<>React, JavaScript, HTML, Bootstrap, CSS</>}
                                git="https://github.com/AntonioCC147/Designer-Website-2" adress="https://designer2-app.netlify.app/"
                            />
                        </Col>
                    </Row>
                </>
            }
            {(view === "All" || view === "Hackathon") && 
                <>
                    <p className="subSubTitle">&lt;Hackathon/&gt;</p>
                    <Row>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="no" linkToGitHub="yes"
                                img={ProiectSign} img1={Sign1} img2={Sign2} img3={Sign3}
                                title={<>Sign Language - Web App</>}
                                description={<>Proiect realizat în cadrul celei de-a doua ediții a Hackathon-ului organizat de către
                                "Departamentul de IT - LSAC".</>}
                                technology={<>React, JavaScript, HTML, Bootstrap, CSS</>}
                                git="https://github.com/AntonioCC147/Mental-Health-HackIT" adress="/"
                            />
                        </Col>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="yes" linkToGitHub="yes"
                                img={ProiectGCCC} img1={CCC1} img2={CCC2} img3={CCC3}
                                title={<>GreenCCC - Web App</>}
                                description={<>Proiectul cu care am câștigat locul 2 la ZebraHack, un Hackahton intern organizat
                                de către facultate la care au participat peste 150 de studenți.</>}
                                technology={<>HTML, CSS, JavaScript</>}
                                git="https://github.com/AntonioCC147/GreenCCC-Website" adress="https://greenccc.netlify.app/"
                            />
                        </Col>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="no" linkToGitHub="yes"
                                img={ProiectMental} img1={Mental1} img2={Mental2} img3={Mental3}
                                title={<>Mental Health - Web App</>}
                                description={<>Proiect realizat în cadrul primei ediții a Hackathon-ului organizat de către
                                "Departamentul de IT - LSAC".</>}
                                technology={<>React, Next.js, TypeScript, HTML, Bootstrap, CSS</>}
                                git="https://github.com/AntonioCC147/Mental-Health-HackIT" adress="/"
                            />
                        </Col>
                    </Row>
                </>
            }
            {(view === "All" || view === "Jocuri") && 
                <>
                    <p className="subSubTitle">&lt;Jocuri/&gt;</p>
                    <Row>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="yes" linkToGitHub="yes"
                                img={ProiectWordScramble} img1={WS1} img2={WS2} img3={WS3}
                                title={<>Word Scramble - Joc</>}
                                description={<>Jocul este unul destul de simplu din punct de vedere al logicii. Acesta dispune atât
                                limba română, cât și limba engleză.</>}
                                technology={<>React, JavaScript, BootStrap</>}
                                git="https://github.com/AntonioCC147/Word-Scramble-Game" adress="https://game-word-scramble.netlify.app/"
                            />
                        </Col>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="yes" linkToGitHub="yes"
                                img={ProiectHangMan} img1={HM1} img2={HM2} img3={HM3}
                                title={<>HangMan - Joc</>}
                                description={<>Jocul este clasicul Spânzurătoarea pe care îl cunoaștem cu toții. Ai de ales litere
                                din alfabet până nimerești cuvântul ori pierzi.</>}
                                technology={<>React, JavaScript, BootStrap</>}
                                git="https://github.com/AntonioCC147/HangMan-Game" adress="https://game-hangman-acc.netlify.app/"
                            />
                        </Col>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="no" linkToGitHub="yes"
                                img={ProiectLitere} img1={Joc1} img2={Joc2} img3={Joc3}
                                title={<>Din Litere în Cifre - Joc</>}
                                description={<>Acest joc presupune scrierea cu litere ale alfabetului a unui număr din intervalul
                                [1, 1.000.000] și ulterior transformarea acestuia în cifre.</>}
                                technology={<>Limbajul C</>}
                                git="https://github.com/AntonioCC147/DinLitereInCifre" adress="/"
                            />
                        </Col>
                    </Row>
                </>
            }
            {(view === "All" || view === "Proiecte") && 
                <>
                    <p className="subSubTitle">&lt;Proiecte / Teme/&gt;</p>
                    <Row>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="no" linkToGitHub="yes"
                                img={ProiectPA} img1={PA1} img2={PA2} img3={PA3}
                                title={<>LanParty - Proiect</>}
                                description={<>Acest proiect a reprezentat un proiect pe semestrul II al primului an de facultate la
                                materia "Structuri de Date și Algoritmi".</>}
                                technology={<>Limbajul C</>}
                                git="https://github.com/AntonioCC147/PA-Project-LanParty" adress="/"
                            />
                        </Col>
                    </Row>
                </>
            }
            {(view === "All" || view === "Departament") && 
                <>
                    <p className="subSubTitle">&lt;Proiecte Departamentul de IT/&gt;</p>
                    <Row>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="no" linkToGitHub="no"
                                img={ProiectCT} img1={CT1} img2={CT2} img3={CT3}
                                title={<>Career Talks - Web App</>}
                                description={<>Am fost "Manager de Departament - IT" în cadrul evenimentului, unde am organizat
                                echipa de IT și am ajuns la rezultatul care se poate vedea.</>}
                                technology={<>React, JavaScript, HTML, Bootstrap, SCSS, CSS</>}
                                git="/" adress="/"
                            />
                        </Col>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="no" linkToGitHub="no"
                                img={ProiectHackIT} img1={HackIT1} img2={HackIT2} img3={HackIT3}
                                title={<>HackITall 1 & 2 - Web App</>}
                                description={<>Am participat ca membru în echipa internă a HackITall 1 și 2 și am ajutat la diferite
                                task-uri pe partea de front-end.</>}
                                technology={<>React, TypeScript, JavaScript, ChakraUI, HTML, CSS</>}
                                git="/" adress="/"
                            />
                        </Col>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="no" linkToGitHub="no"
                                img={ProiectCSA} img1={CSA1} img2={CSA2} img3={CSA3}
                                title={<>CSA - Web App</>}
                                description={<>Am participat ca membru în echipa internă a CSA și am ajutat la diferite task-uri pe
                                partea de front-end.</>}
                                technology={<>React, JavaScript, HTML, CSS</>}
                                git="/" adress="/"
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <PortofoliuCard
                                language="RO" linkToProject="no" linkToGitHub="no"
                                img={ProiectGAP} img1={GAP1} img2={GAP2} img3={GAP3}
                                title={<>Admin Panel - Boilerplate</>}
                                description={<>Având responsabilitatea de "Team Lead", am organizat echipa și am creat un Generic
                                Admin Panel ușor de folosit, fiind un proiect open-source.</>}
                                technology={<>React, TypeScript, JavaScript, HTML, CSS</>}
                                git="/" adress="/"
                            />
                        </Col>
                    </Row>
                </>
            }
        </Container>
    );
}